
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "HomeEvent",
  props: {
    events: Array as PropType<Array<{ href: string; title: string }>>,
  },
});
